import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["referralExplanation", "referralRequired"];

  setReferralExplanationRequired() {
    this.referralExplanationTarget.required = this.referralRequiredTarget.value == "true";
  }
}
